import Constants from '../../constants';
import './index.css';
const WalletTransactionsCard = ({ walletTitle, walletBalance, walletBtnTitle, onPress }: any) => {
  const walletIcon = (walletTitle: string) => {
    switch (walletTitle) {
      case 'iGamio Wallet':
        return <Constants.Svgs.GamioGLogo />;
      case 'Winnings':
        return <Constants.Svgs.RupeeNote />;

      case 'Poker Wallet':
        return <Constants.Svgs.Poker />;

      case 'Bonus':
        return <Constants.Svgs.Giftbox />;
      case 'Cashback':
        return <Constants.Svgs.Giftbox />;
    }
  };
  return (
    <div className="wallet_history_card_container">
      <div className="wallet_category_container wallet_history_col">
        {walletIcon(walletTitle)}

        <p>{walletTitle}</p>
      </div>
      <div className="wallet_history_seperator"></div>
      <div className="wallet_history_col">
        <p>{`₹${walletBalance}`}</p>
      </div>

      <div className="wallet_history_seperator"></div>
      <div className="wallet_history_col">
        <button className="wallet_transactions_btn" onClick={onPress}>
          {walletBtnTitle}
        </button>
      </div>
    </div>
  );
};

export default WalletTransactionsCard;
